import { render, staticRenderFns } from "./lista_de_documentos.vue?vue&type=template&id=3e8907f7&lang=pug&"
import script from "./lista_de_documentos.vue?vue&type=script&lang=js&"
export * from "./lista_de_documentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports